import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-shell" }

import AppCard from "@/shared/components/ui/AppCard.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'TermsPrivacyPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppCard, {
      class: "terms-card",
      unstyled: ""
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("h2", { class: "section-title" }, "Terms & Conditions", -1),
        _createElementVNode("p", { class: "section-text" }, " By using our services, you agree to follow the rules outlined in these Terms and Conditions. You must provide accurate information and keep your account credentials secure. ", -1),
        _createElementVNode("p", { class: "section-text" }, " Payments are due at the time of booking unless otherwise stated. We may cancel or reschedule services due to availability, safety concerns, or unforeseen circumstances. ", -1),
        _createElementVNode("p", { class: "section-text" }, " We are not responsible for delays caused by third parties or events outside of our control. Service quality concerns should be reported within 48 hours of completion. ", -1),
        _createElementVNode("h2", { class: "section-title" }, "Privacy Policy", -1),
        _createElementVNode("p", { class: "section-text" }, " We collect your name, contact details, and service preferences to provide and improve our services. We do not sell your personal data. ", -1),
        _createElementVNode("p", { class: "section-text" }, " Your information may be shared with service professionals to complete your booking. We use industry-standard security measures to protect your data. ", -1),
        _createElementVNode("p", { class: "section-text" }, " You can request access, updates, or deletion of your data by contacting support. Response times may vary based on request volume. ", -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})